export function is_non_empty_string(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

/**
 * Normalizes lock identifiers by trimming, removing empties and de-duplicating.
 * @param {Array<string>} lock_identifiers
 * @returns {Array<string>}
 */
export function normalize_lock_identifiers(lock_identifiers = []) {
  if (!Array.isArray(lock_identifiers)) return [];

  const normalized_lock_identifiers = [];
  const seen_lock_identifiers = new Set();
  for (const raw_lock_identifier of lock_identifiers) {
    if (!is_non_empty_string(raw_lock_identifier)) continue;

    const normalized_lock_identifier = raw_lock_identifier.trim();
    if (seen_lock_identifiers.has(normalized_lock_identifier)) continue;

    seen_lock_identifiers.add(normalized_lock_identifier);
    normalized_lock_identifiers.push(normalized_lock_identifier);
  }

  return normalized_lock_identifiers;
}
